module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goToField":"Go to field"},"id":{"goToField":"Menuju lapangan"}}')
  delete Component.options._Ctor
}
